import { Button, Text, Grid, Box, Flex, Spinner, keyframes } from '@chakra-ui/react';
import { generalUtils } from '@shared/common';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';

import CheckSVG from '~/assets/icons/check.svg';
import { useAppLead } from '~/hooks/useAppLead';
import { useAppRouter } from '~/hooks/useAppRouter';
import { useFreshState } from '~/hooks/useFreshState';
import { useProducts } from '~/hooks/useProducts';
import { useTracking } from '~/hooks/useTracking';
import { colors } from '~/theme';
import { AppRoute } from '~/types';

import { Arrow } from '../Arrow';

export const PlanSelection = () => {
  const { updateLead } = useAppLead();
  const { mainProducts } = useProducts();
  const { plansSelect } = useTracking();
  const { pushNextRoute } = useAppRouter(AppRoute.CHECKOUT);
  const [activePlan, setActivePlan] = useFreshState(mainProducts[6]);
  const activePlanId = activePlan?.id;

  const handleClick = () => {
    if (activePlan) {
      updateLead({ selectedPlan: activePlan });

      plansSelect({
        category: activePlan.key,
        label: activePlan.title,
      });

      pushNextRoute();
    }
  };

  return (
    <>
      <Grid width='100%' gap='0.5rem' gridTemplateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(1, 1fr)' }}>
        {(() => {
          const product = mainProducts[3];
          const productId = product?.id;
          const productPrice = product?.prices?.find((p) => p.currency === 'USD');
          const finalPrice = productPrice?.finalPrice || 0;
          const price = productPrice?.price || 0;

          return product ? (
            <Box
              border='2px solid'
              borderRadius='0.5rem'
              width='100%'
              padding={{ base: '1rem', md: '1rem 1.5rem' }}
              position='relative'
              borderColor={activePlanId === productId ? 'primary' : '#DBDDD8'}
              backgroundColor={activePlanId === productId ? '#fbf8fc' : 'white'}
              onClick={() => setActivePlan(product)}
              cursor='pointer'
              transition='all 200ms'
              marginBottom={{ base: '10px', md: '6px' }}
            >
              {product ? (
                <Flex alignItems='center' gap='1rem'>
                  <Flex>
                    {activePlanId === productId ? (
                      <CheckSVG width='24px' height='24px' fill={colors.primary} />
                    ) : (
                      <Box width='24px' height='24px' border='2px solid #D1D3CD' borderRadius='1.5rem' />
                    )}
                  </Flex>
                  <Flex
                    flex={1}
                    gap={{ base: '1.5rem', md: '1.5rem' }}
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <Flex gap={{ base: '1rem', md: '1.5rem' }} flex='1' alignItems='center'>
                      <Box>
                        <Text
                          fontWeight={700}
                          fontSize={{ base: '20px', md: '24px' }}
                          marginBottom={{ base: '0.25rem', md: '0.375rem' }}
                          lineHeight='100%'
                          color='primary.text'
                        >
                          3 months plan
                        </Text>
                        <Flex gap='0.5rem' alignItems='center '>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='#C73E1D' textDecoration='line-through'>
                            {generalUtils.formatPrice(price, 'USD')}
                          </Text>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='rgba(5, 5, 23, 0.64)'>
                            {generalUtils.formatPrice(finalPrice, 'USD')}
                          </Text>
                        </Flex>
                      </Box>
                    </Flex>
                    <Box textAlign='center'>
                      <Text
                        textDecoration='line-through'
                        fontSize='14px'
                        color={activePlanId === productId ? '#C73E1D' : 'rgba(5, 5, 23, 0.64)'}
                      >
                        {generalUtils.formatPrice(price / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text fontSize={{ base: '24px', md: '30px' }} fontWeight={900} lineHeight='120%'>
                        {generalUtils.formatPrice(finalPrice / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text color='rgba(5, 5, 23, 0.64)' fontSize='14px'>
                        per day
                      </Text>
                    </Box>
                  </Flex>
                </Flex>
              ) : (
                <Flex justifyContent='center'>
                  <Spinner />
                </Flex>
              )}
            </Box>
          ) : (
            <Flex justifyContent='center'>
              <Spinner />
            </Flex>
          );
        })()}
        {(() => {
          const product = mainProducts[6];
          const productId = product?.id;
          const productPrice = product?.prices?.find((p) => p.currency === 'USD');
          const finalPrice = productPrice?.finalPrice || 0;
          const price = productPrice?.price || 0;

          return product ? (
            <Box
              border='2px solid'
              borderRadius='0.5rem'
              width='100%'
              padding={{ base: '1rem', md: '1rem 1.5rem' }}
              position='relative'
              borderColor={activePlanId === productId ? 'primary' : '#DBDDD8'}
              backgroundColor={activePlanId === productId ? '#fbf8fc' : 'white'}
              onClick={() => setActivePlan(product)}
              cursor='pointer'
              transition='all 200ms'
            >
              {product ? (
                <Flex alignItems='center' gap='1rem'>
                  <Flex>
                    {activePlanId === productId ? (
                      <CheckSVG width='24px' height='24px' fill={colors.primary} />
                    ) : (
                      <Box width='24px' height='24px' border='2px solid #D1D3CD' borderRadius='1.5rem' />
                    )}
                  </Flex>
                  <Flex
                    flex={1}
                    gap={{ base: '1.5rem', md: '1.5rem' }}
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <Flex justifyContent='center' position='absolute' top='-0.75rem' left='0' right='0' zIndex={10}>
                      <Text
                        display='inline-block'
                        padding='0.25rem 1rem'
                        borderRadius='4px'
                        backgroundColor='#FFD442'
                        fontWeight={500}
                        fontSize='11px'
                        textAlign='center'
                        color='black'
                      >
                        BEST VALUE: {100 - Math.round((finalPrice / price) * 100)}% OFF
                      </Text>
                    </Flex>
                    <Flex gap={{ base: '1rem', md: '1.5rem' }} flex='1' alignItems='center'>
                      <Box>
                        <Text
                          fontWeight={700}
                          fontSize={{ base: '20px', md: '24px' }}
                          marginBottom={{ base: '0.25rem', md: '0.375rem' }}
                          lineHeight='100%'
                          color='primary.text'
                        >
                          6 months plan
                        </Text>
                        <Flex gap='0.5rem' alignItems='center '>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='#C73E1D' textDecoration='line-through'>
                            {generalUtils.formatPrice(price, 'USD')}
                          </Text>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='rgba(5, 5, 23, 0.64)'>
                            {generalUtils.formatPrice(finalPrice, 'USD')}
                          </Text>
                        </Flex>
                      </Box>
                    </Flex>
                    <Box textAlign='center'>
                      <Text
                        textDecoration='line-through'
                        fontSize='14px'
                        color={activePlanId === productId ? '#C73E1D' : 'rgba(5, 5, 23, 0.64)'}
                      >
                        {generalUtils.formatPrice(price / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text fontSize={{ base: '24px', md: '30px' }} fontWeight={900} lineHeight='120%'>
                        {generalUtils.formatPrice(finalPrice / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text color='rgba(5, 5, 23, 0.64)' fontSize='14px'>
                        per day
                      </Text>
                    </Box>
                  </Flex>
                </Flex>
              ) : (
                <Flex justifyContent='center'>
                  <Spinner />
                </Flex>
              )}
            </Box>
          ) : (
            <Flex justifyContent='center'>
              <Spinner />
            </Flex>
          );
        })()}
        {(() => {
          const product = mainProducts[1];
          const productId = product?.id;
          const productPrice = product?.prices?.find((p) => p.currency === 'USD');
          const finalPrice = productPrice?.finalPrice || 0;
          const price = productPrice?.price || 0;

          return product ? (
            <Box
              border='2px solid'
              borderRadius='0.5rem'
              width='100%'
              padding={{ base: '1rem', md: '1rem 1.5rem' }}
              position='relative'
              borderColor={activePlanId === productId ? 'primary' : '#DBDDD8'}
              backgroundColor={activePlanId === productId ? '#fbf8fc' : 'white'}
              onClick={() => setActivePlan(product)}
              cursor='pointer'
              transition='all 200ms'
            >
              {product ? (
                <Flex alignItems='center' gap='1rem'>
                  <Flex>
                    {activePlanId === productId ? (
                      <CheckSVG width='24px' height='24px' fill={colors.primary} />
                    ) : (
                      <Box width='24px' height='24px' border='2px solid #D1D3CD' borderRadius='1.5rem' />
                    )}
                  </Flex>
                  <Flex
                    flex={1}
                    gap={{ base: '1.5rem', md: '1.5rem' }}
                    justifyContent='space-between'
                    alignItems='center'
                  >
                    <Flex gap={{ base: '1rem', md: '1.5rem' }} flex='1' alignItems='center'>
                      <Box>
                        <Text
                          fontWeight={700}
                          fontSize={{ base: '20px', md: '24px' }}
                          marginBottom={{ base: '0.25rem', md: '0.375rem' }}
                          lineHeight='100%'
                          color='primary.text'
                        >
                          1 month plan
                        </Text>
                        <Flex gap='0.5rem' alignItems='center '>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='#C73E1D' textDecoration='line-through'>
                            {generalUtils.formatPrice(price, 'USD')}
                          </Text>
                          <Text fontSize={{ base: '12px', md: '14px' }} color='rgba(5, 5, 23, 0.64)'>
                            {generalUtils.formatPrice(finalPrice, 'USD')}
                          </Text>
                        </Flex>
                      </Box>
                    </Flex>
                    <Box textAlign='center'>
                      <Text
                        textDecoration='line-through'
                        fontSize='14px'
                        color={activePlanId === productId ? '#C73E1D' : 'rgba(5, 5, 23, 0.64)'}
                      >
                        {generalUtils.formatPrice(price / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text fontSize={{ base: '24px', md: '30px' }} fontWeight={900} lineHeight='120%'>
                        {generalUtils.formatPrice(finalPrice / (product.plan.interval * 30), 'USD')}
                      </Text>
                      <Text color='rgba(5, 5, 23, 0.64)' fontSize='14px'>
                        per day
                      </Text>
                    </Box>
                  </Flex>
                </Flex>
              ) : (
                <Flex justifyContent='center'>
                  <Spinner />
                </Flex>
              )}
            </Box>
          ) : (
            <Flex justifyContent='center'>
              <Spinner />
            </Flex>
          );
        })()}
      </Grid>
      <Button
        width='100%'
        animation={`10s ease 0s infinite normal none running ${firstPulse}`}
        gap='1rem'
        marginBottom='0.5rem'
        onClick={() => handleClick()}
        isDisabled={!activePlan}
      >
        <Text color='white'>Claim my plan</Text>
        <Arrow fill='white' dir='right' />
      </Button>
      <Flex
        marginBottom='1rem'
        gap='1rem'
        alignItems='center'
        width='100%'
        padding='1rem'
        borderRadius='0.5rem'
        bg='#D7EDFD'
      >
        <Flex>
          <CoinSVG />
        </Flex>
        <Text
          flex={1}
          fontSize={{ base: '14px', md: '15px' }}
          fontWeight={500}
          lineHeight='130%'
        >{`Lose 7 lbs until ${format(addDays(new Date(), 84), 'LLLL d, yyyy')} and get the full refund!`}</Text>
      </Flex>
    </>
  );
};

const firstPulse = keyframes`
  0% {box-shadow: 0 0 0 0 ${colors.primary};}
  20% {box-shadow: transparent 0px 0px 0px 14px}
`;

const CoinSVG = () => (
  <>
    <svg width='48' height='48' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M80 40C80 61.8153 62.3153 79.5 40.5 79.5C18.6848 79.5 1 61.8153 1 40C1 18.1848 18.6848 0.5 40.5 0.5C62.3153 0.5 80 18.1848 80 40Z'
        fill='#FFD442'
        stroke='#233E20'
      />
      <g clipPath='url(#clip0_613_1310)'>
        <path
          d='M22.5339 36.2363C20.6442 33.8199 20.0829 31.7855 20.9107 30.3533L21.8646 28.7008C22.4199 27.7387 22.9754 26.7762 23.532 25.8135C24.4181 24.2787 26.7795 23.7767 30.1808 24.4002C33.3975 24.9898 37.2375 26.5088 40.9933 28.6773C42.7925 29.7165 44.47 30.8434 45.9793 32.0269L45.3056 32.8862C43.8366 31.7342 42.202 30.6363 40.4473 29.6228C36.7969 27.5152 33.0809 26.0418 29.9839 25.4741C27.1133 24.9479 25.1062 25.2707 24.4774 26.3598C23.2738 28.4455 27.1509 33.7407 34.8411 38.2993L34.2843 39.2385C30.6486 37.0833 27.5329 34.5612 25.511 32.1368C24.3633 30.7606 23.6289 29.478 23.3268 28.3523C23.1547 28.6504 22.9822 28.9487 22.8103 29.2467L21.8561 30.8995C21.3845 31.7156 21.688 33.0212 22.6838 34.5687L23.5097 33.1365L24.4555 33.6819L23.3805 35.5462L23.394 35.5637C24.1319 36.5073 25.0659 37.4829 26.1526 38.4538L27.0881 36.8319L28.0339 37.3773L26.9945 39.1794C28.161 40.1508 29.4709 41.108 30.8817 42.0137L30.2918 42.9325C27.0265 40.8362 24.2714 38.4581 22.5339 36.2363ZM30.9879 28.2513C33.318 28.945 36.2042 30.2523 39.1145 31.9323C40.3249 32.6319 41.4836 33.3633 42.5585 34.1058L43.179 33.2075C42.0802 32.4483 40.8965 31.7013 39.6606 30.9869C36.6783 29.2653 33.7089 27.9221 31.2993 27.2048C28.5864 26.3972 26.9263 26.4801 26.3655 27.4512C25.8043 28.4215 26.5625 29.9001 28.6189 31.846C30.4452 33.5741 33.0933 35.4744 36.0766 37.1977C36.2703 37.309 36.4661 37.4202 36.6597 37.5294L37.1955 36.5781C37.0037 36.4701 36.8124 36.3613 36.6215 36.2517C33.711 34.5704 31.1354 32.7241 29.3693 31.053C27.4135 29.2023 27.1674 28.2453 27.3107 27.9975C27.4542 27.7494 28.4072 27.4831 30.9879 28.2513ZM57.9976 44.0961C55.8786 46.588 52.6434 49.1545 48.8883 51.3226C45.1312 53.4912 41.2906 55.0101 38.0738 55.5998C37.1208 55.7744 36.2491 55.8609 35.469 55.8609C33.4644 55.8609 32.0625 55.2912 31.4245 54.1862C30.813 53.126 30.2011 52.0661 29.5888 51.0065L28.8032 49.6464C27.9169 48.1112 28.6625 45.8148 30.9029 43.1801C33.0222 40.688 36.2581 38.1214 40.0144 35.9533C43.7695 33.7852 47.6099 32.2666 50.828 31.677C54.23 31.0541 56.5916 31.5555 57.478 33.0896L60.0973 37.632C60.9834 39.1658 60.2379 41.4615 57.9976 44.0961ZM29.7488 49.1005L29.7489 49.1006C30.3776 50.1895 32.3848 50.5122 35.2557 49.9861C38.3528 49.4184 42.0695 47.945 45.7211 45.8373C49.3713 43.7298 52.5054 41.2479 54.5458 38.8487C56.4369 36.6252 57.1611 34.7253 56.5327 33.6362L56.5323 33.6355C55.9037 32.5476 53.8962 32.2251 51.0247 32.7511C47.9264 33.3187 44.21 34.7917 40.5603 36.899C36.9094 39.0063 33.7751 41.4882 31.7347 43.8876C29.8437 46.1111 29.1199 48.0112 29.7488 49.1005ZM59.1516 38.1778L57.6827 35.6304C57.3696 36.7941 56.5946 38.1249 55.3775 39.556C53.2581 42.0479 50.0226 44.6144 46.267 46.7828C42.51 48.9514 38.6693 50.4703 35.4525 51.0599C34.4996 51.2346 33.6279 51.3209 32.8477 51.321C32.1154 51.321 31.4639 51.2447 30.9004 51.0943C31.3904 51.9428 31.8807 52.7915 32.3703 53.6405C32.8476 54.4672 34.1206 54.8517 35.9623 54.7587L35.1353 53.3237L36.0813 52.7786L37.1554 54.6424C37.3895 54.6097 37.6298 54.5711 37.877 54.5258C38.8805 54.3418 39.9494 54.0623 41.0598 53.6973L40.1218 52.0733L41.0672 51.5272L42.1093 53.3315C43.2701 52.9041 44.4668 52.3901 45.675 51.7988L44.7143 50.1324L45.6602 49.5871L46.651 51.3058C47.7911 50.7112 48.9053 50.068 49.9904 49.378L48.9979 47.6595L49.9433 47.1135L50.9054 48.7794C52.0212 48.0291 53.0645 47.2498 54.0148 46.4583L52.9739 44.6534L53.9197 44.108L54.8565 45.7323C55.7279 44.9529 56.5047 44.1666 57.1659 43.3889C57.3236 43.2034 57.4775 43.0147 57.6272 42.8227L56.5523 40.9604L57.4979 40.4146L58.3248 41.8471C59.3258 40.2984 59.629 39.0041 59.1516 38.1778ZM31.6368 48.0087C31.0768 47.038 31.8353 45.5592 33.8911 43.6133C35.7181 41.884 38.366 39.9838 41.3471 38.263C44.3293 36.5413 47.2988 35.1982 49.7083 34.4808C52.4214 33.6732 54.0814 33.7562 54.6423 34.7275C55.2033 35.6988 54.445 37.178 52.3887 39.1237C50.5625 40.8518 47.9143 42.7516 44.932 44.4733C41.9497 46.1949 38.9803 47.5381 36.5707 48.2554C35.3399 48.6218 34.3258 48.8049 33.5327 48.8049C32.5776 48.8048 31.9432 48.5394 31.6368 48.0087ZM32.5824 47.4629C32.7255 47.7108 33.6785 47.9771 36.2592 47.2089C38.5893 46.5152 41.4755 45.2079 44.3861 43.5276C47.2966 41.8475 49.8721 40.0018 51.6382 38.3307C53.5941 36.4799 53.84 35.5217 53.6967 35.2736C53.5533 35.0255 52.6004 34.7592 50.0197 35.5273C47.6896 36.221 44.8033 37.5283 41.8929 39.2086C38.9836 40.8881 36.4084 42.734 34.6415 44.4064C32.6859 46.2575 32.4394 47.2151 32.5824 47.4629ZM24.7583 43.2755H23.6665V44.659H22.2829V45.7508H23.6665V47.1344H24.7583V45.7508H26.1419V44.659H24.7583V43.2755ZM48.0472 30.6354H49.139V29.2518H50.5204V28.16H49.1391V26.7764H48.0473V28.16H46.6637V29.2518H48.0473V30.6354H48.0472Z'
          fill='#233E20'
        />
      </g>
      <path
        d='M42.8134 4.9797C42.6182 5.17496 42.6182 5.49154 42.8134 5.68681L45.9954 8.86879C46.1907 9.06405 46.5073 9.06405 46.7025 8.86879C46.8978 8.67352 46.8978 8.35694 46.7025 8.16168L43.8741 5.33325L46.7025 2.50482C46.8978 2.30956 46.8978 1.99298 46.7025 1.79772C46.5073 1.60246 46.1907 1.60246 45.9954 1.79772L42.8134 4.9797ZM75.3337 39.9999C75.3337 58.8981 60.9046 74.1666 43.167 74.1666V75.1666C61.512 75.1666 76.3337 59.3935 76.3337 39.9999H75.3337ZM43.167 5.83325C60.9046 5.83325 75.3337 21.1018 75.3337 39.9999H76.3337C76.3337 20.6063 61.512 4.83325 43.167 4.83325V5.83325Z'
        fill='#233E20'
      />
      <path
        d='M38.1866 75.0201C38.3818 74.8249 38.3818 74.5083 38.1866 74.313L35.0046 71.131C34.8093 70.9358 34.4927 70.9358 34.2975 71.131C34.1022 71.3263 34.1022 71.6429 34.2975 71.8381L37.1259 74.6666L34.2975 77.495C34.1022 77.6903 34.1022 78.0068 34.2975 78.2021C34.4927 78.3974 34.8093 78.3974 35.0046 78.2021L38.1866 75.0201ZM5.66634 39.9999C5.66634 21.1018 20.0954 5.83323 37.833 5.83323L37.833 4.83323C19.488 4.83323 4.66634 20.6063 4.66634 39.9999L5.66634 39.9999ZM37.833 74.1666C20.0954 74.1666 5.66634 58.898 5.66634 39.9999L4.66634 39.9999C4.66634 59.3935 19.488 75.1666 37.833 75.1666L37.833 74.1666Z'
        fill='#233E20'
      />
      <defs>
        <clipPath id='clip0_613_1310'>
          <rect width='40' height='40' fill='white' transform='translate(20.5 20)' />
        </clipPath>
      </defs>
    </svg>
  </>
);
